import { OnInit, AfterViewChecked, Component } from '@angular/core';
import { Usuario } from '../../../models/usuario';
import { Perfis } from '../../../models/perfis';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { AuthService } from '../../admin/auth.service';
import { UnidadeService } from '../../shared/services/unidade.service';
import { EmpresaService } from '../../../services/empresa.service';

import { ConfirmationService } from 'primeng/primeng';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Empresa } from '../../../models/empresa.model';
import { Util } from '../../shared/util';

declare var $: any;

@Component({
  templateUrl: './gerenciar-propostas.component.html'

})

export class GerenciarPropostasComponent extends WebPage implements OnInit, AfterViewChecked {
  formGerenciarPropostas: FormGroup;
  listaStatus = [
    {descricao: 'Aguadando análise', idStatus: '5E7478ED-D7E7-4746-8142-7C6DF0249080'},
    {descricao: 'Aprovado', idStatus: '32BAB650-B896-4733-AFBA-7A6FD8119339'},
    {descricao: 'Reprovado', idStatus: '5D4204C1-05A7-4F01-B04A-6C52EC42872F'},
    {descricao: 'Aprovado Parcialmente', idStatus: '8F9B683D-E01C-4811-9A67-265E5EE1A250'},
  ]

  usuario: Usuario;
  display = false;
  perfis;

  listaEmpresas: Empresa[] = [];
  listaEmpresasEmail: string[] = [];
  
  unidades;
  public isEnviando = false;
  constructor(
    private authService: AuthService,
    private unidadeService: UnidadeService,
    private empresaService: EmpresaService,
    private fb: FormBuilder,
    messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {
    super(messageService);

    this.usuario = this.authService.informacoesUsuario();
    this.perfis = Perfis;

    this.formGerenciarPropostas = fb.group({
      cnpj: [null],
      razaoSocial: [null],
      idUnidade: [null],
      idStatus: [null],
    });
  }

  ngOnInit() {
    if (
      this.usuario.Perfil === Perfis.AdministradorSistema
      || this.usuario.Perfil === Perfis.GestorDex
      || this.usuario.Perfil === Perfis.AdministrativoDex
    ) {
        this.isLoading = true;
        this.empresaService.getAll("", "", "",1,10, null)
        .finally(() => this.isLoading = false)
        .subscribe(
          data => {
            console.log(data);
            this.listaEmpresas = data;
          },
          error => this.gerenciaErro(error)
        );
    }
    this.carregarUnidades();
  }

  carregarUnidades() {
        this.isLoading = true;
        this.unidadeService.getUnidades()
        .finally(() => this.isLoading = false)
        .subscribe(
            unidades => this.unidades = unidades,
            error => this.gerenciaErro(error)
        );
    }

  submitformGerenciarPropostas() {
    //console.log("teste envio");
    if (!this.formGerenciarPropostas.valid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Campo obrigatório não preenchido!'
      });
      return;
    }

    this.confirmationService.confirm({
      message: 'Deseja mesmo alterar o status deste aluno?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
          // this.candidatoService.alterarStatusCandidato(this.formGerenciarPropostas.value)
          // .subscribe(candidato => {
          //   console.log(candidato);

          //   this.candidato = null;
          //   this.formGerenciarPropostas.reset();
          // },
          // error => this.gerenciaErro(error));
      }
    });
}

  ngAfterViewChecked() {
    $('[data-toggle="tooltip"]').tooltip();
  }

  verificarPermissaoEditarCanidato() {
    if (
      this.usuario.Perfil === Perfis.AdministradorSistema
      || this.usuario.Perfil === Perfis.GestorDex
      || this.usuario.Perfil === Perfis.AdministrativoDex
    ) {
      return true;
    }
    return false;

  }

  concluirProcesso(candidato:any){
    this.confirmationService.confirm({
      message: 'Deseja declarar o processo deste candidato como concluído?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {


        // this.candidatoService.concluirProcesso(candidato.idCandidato)
        //   .subscribe(res => {

        //     candidato.idStatusCandidato =  StatusCandidato.Concluido;

        //     this.messageService.add({
        //       severity: 'success',
        //       summary: 'Atenção',
        //       detail: 'O processo foi concluído com sucesso'
        //     });
        //   },
        //   error => this.gerenciaErro(error));

      }
    });
  }

  getStatus(valor){
    let status = this.listaStatus.filter( s => {
      return s.idStatus == valor.toUpperCase();
    });    
    return status ? status[0].descricao : '';
  }

  pesquisar(){
    this.isLoading = true;
    var razao = this.formGerenciarPropostas.controls.razaoSocial.value;
    var cnpj = this.formGerenciarPropostas.controls.cnpj.value;
    var unidade = this.formGerenciarPropostas.controls.idUnidade.value;
    var status = this.formGerenciarPropostas.controls.idStatus.value;
    var statusTem = "";
    if(status) {statusTem = this.listaStatus.filter(s => s.idStatus == status)[0].descricao}

    this.empresaService.getAll(statusTem, cnpj, razao, 1,10,unidade)
    .finally( () => {
      this.isLoading = false;
    })
    .subscribe(
      (data) => {
        this.listaEmpresas = data;
      }
    )
  }

  onCheckboxChange(event){
    if(this.listaEmpresasEmail.filter( e => e == event).length > 0){
      this.listaEmpresasEmail = this.listaEmpresasEmail.filter( e => e !== event)
      //alert(this.listaEmpresasEmail)
    }else{
      this.listaEmpresasEmail.push(event);
      //alert(event);
    }
  }
  enviarEmail(){
    this.isEnviando = true;
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja realizar o envio para as empresas selecionadas?',
      header: 'Enviar E-mails',
      icon: 'fa fa-question-circle',
      accept: () => {
        //alert(this.usuario.Nome);
          this.empresaService.enviarEmails(this.listaEmpresasEmail, this.usuario.Nome)
          .finally( () => { this.isEnviando = false; })
          .subscribe(data => {
            if(data){
              this.listaEmpresas.forEach(
                (empresa, index) => {
                  data.empresaIds.forEach(
                    (empresaId) => {
                      if(empresa.idEmpresa == empresaId){
                        this.listaEmpresas[index].isEmailEntregue = true;
                      }
                    }
                  )
                }
              )
              this.messageService.add({
                summary: 'E-mails',
                detail: 'E-mails enviados com sucesso',
                severity: 'success',
              })
            }
          },
          error => this.gerenciaErro(error));
      },
      reject: () => {
        this.isEnviando = false;
      }
    });
  }
  onPermitirEditar(value){
    if(value){
      return (value.toUpperCase() == '5D4204C1-05A7-4F01-B04A-6C52EC42872F' || //Reprovado
        value.toUpperCase() == '8F9B683D-E01C-4811-9A67-265E5EE1A250' || //Parcialmente
        value.toUpperCase() == '32BAB650-B896-4733-AFBA-7A6FD8119339') //Aprovado
    }
  }
  onPermitirAnalisar(value){
    if(value){
      return (value.toUpperCase() == '5E7478ED-D7E7-4746-8142-7C6DF0249080') //em analise
    }
  }
  onPermitirHistorico(value){
    if(value){
      return (value.toUpperCase() == '8F9B683D-E01C-4811-9A67-265E5EE1A250' || //Parcialmente
              value.toUpperCase() == '32BAB650-B896-4733-AFBA-7A6FD8119339') // Aprovado
    }
  }
  getCnpjFormatado(value){
    return Util.formatAsCnpj(value);
  }

  getItem(value){
    if(value.idFase)
    return JSON.stringify(value.fase.nomeFase);
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/app/components/vaga/gerenciar/gerenciar-propostas.component.ts